// 待开始邀请信息
export default {
  // 开启命名空间
  namespaced: true,
  state: {
    isShowToast: false
  },
  mutations: {
    showToast(state) {
      state.isShowToast = true;
    },
    hideToast(state) {
      state.isShowToast = false;
    }
  },
  actions: {
    showToast(store) {
      store.commit("showToast")
    },
    closeToast(store) {
      store.commit("hideToast")
    },
  },
  getters: {
    userInfo: state => {
      return state.userInfo;
    }
  }
}